<template>
    <div class="content-wrapper">
        <div class="overlay" v-if="isLoading"></div>

        <accounting-address-step 
            v-if="'accounting-address' == currentStep"
            :social-certificate="localSocialCertificate"
            @field-updated="handleFieldValueUpdated($event)"
            @current-step-changed="currentStep = $event"
        >
        </accounting-address-step>

        <social-address-step 
            v-else-if="'social-address' == currentStep"
            :social-certificate="localSocialCertificate"
            @field-updated="handleFieldValueUpdated($event)"
            @current-step-changed="currentStep = $event"
        >
        </social-address-step>
        
        <customer-employees-step 
            v-else-if="'customer-employees' == currentStep"
            :social-certificate="localSocialCertificate"
            @field-updated="handleFieldValueUpdated($event)"
            @current-step-changed="currentStep = $event"
        >
        </customer-employees-step>

        <form-summary-step
            v-else-if="'form-summary' == currentStep"
            :social-certificate="localSocialCertificate"
            @current-step-changed="currentStep = $event"
            @form-validated="sendEditionForm"
        >
        </form-summary-step>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'
    import AccountingAddressStep from './EditionForm/AccountingAddressStep'
    import SocialAddressStep from './EditionForm/SocialAddressStep'
    import CustomerEmployeesStep from './EditionForm/CustomerEmployeesStep'
    import FormSummaryStep from './EditionForm/FormSummaryStep'

    export default {
        components: {
            AccountingAddressStep,
            SocialAddressStep,
            CustomerEmployeesStep,
            FormSummaryStep
        },

        props: {
            socialCertificate: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                isLoading: false,
                localSocialCertificate: null,
                currentStep: 'accounting-address'
            }
        },

        created() {
            let socialCertificate = _.cloneDeep(this.socialCertificate)

            if (!socialCertificate.accounting_address) {
                socialCertificate.accounting_address = {}
            }
            
            if (!socialCertificate.social_address) {
                socialCertificate.social_address = {}
            }
            
            if (!socialCertificate.customer) {
                socialCertificate.customer = {}
            }
            
            if (!socialCertificate.last_update) {
                socialCertificate.last_update = {}
            }

            this.localSocialCertificate = socialCertificate
        },

        methods: {
            ...mapActions('customer', ['updateSocialCertificate']),

            handleFieldValueUpdated($event) {
                // console.log($event)

                const splittedIndex = $event.idx.split('.')
                const model = splittedIndex[0], attribute = splittedIndex[1]

                if ('select' == $event.type) {
                    if ($event.new_value && $event.new_value.hasOwnProperty('value')) {
                        this.$set(this.localSocialCertificate[model], attribute, $event.new_value.value)

                        this.$set(this.localSocialCertificate[model], 'decoded_' + attribute, $event.new_value.label)
                    }
                } else {
                    this.$set(this.localSocialCertificate[model], attribute, $event.new_value)
                }
            },

            sendEditionForm() {
                // console.log(this.localSocialCertificate)

                this.isLoading = true

                this.updateSocialCertificate(this.localSocialCertificate)
                    .then(() => {
                        this.isLoading = false

                        this.$emit('update-terminated')
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .content-wrapper {
        position: relative;
        
        .overlay {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(255, 255, 255, 0.5);
        }
    }
</style>

<style>
    .buttons {
        margin-top: 20px;
    }
</style>


// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/SocialCertificate/EditionForm.vue